import React from 'react';
import { useSelector } from 'react-redux';
import { getProfileToDisplay } from 'reducer/profileRedux';
import { Tooltip } from 'seedly-component-library';
import Image from 'next/image';
import { imageUrl } from 'theme';
import { Info } from 'react-feather';
import dayjs from 'dayjs';

const TOP_CONTRIBUTOR =
  'Given monthly to 10 contributors who have managed to obtain the highest amount of upvotes given by the community';

const getContributingYears = badges => {
  if (!badges || badges.length === 0) return '';

  const badgeYear = badges.map(badge => {
    return `${dayjs(badge.expiresAt).subtract(1, 'month').format('MMM YYYY')}`;
  });

  return badgeYear.join(' · ');
};

const ProfileTopContributeCard = () => {
  const profile = useSelector(getProfileToDisplay);
  const badgeYear = getContributingYears(profile.badges);

  if (!badgeYear) return null;

  return (
    <div className="card">
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <p className="text-lg font-bold">Top Contributor</p>
          <div style={{ paddingTop: '4px' }}>
            <Image src={imageUrl.badge} height={24} width={18} />
          </div>
          <Tooltip
            showToolTip
            placement="top"
            renderTriggerButton={() => {
              return <Info size={14} />;
            }}
            renderToolTipBody={() => (
              <div style={{ width: '200px', flexWrap: 'wrap' }}>
                {TOP_CONTRIBUTOR}
              </div>
            )}
          />
        </div>
        <p>{badgeYear}</p>
      </div>
    </div>
  );
};

export default ProfileTopContributeCard;
